import { memo } from "react";

const VideoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4354 6.97518L9.27947 1.72452C8.72057 1.31526 8.05924 1.06879 7.36881 1.01243C6.67838 0.956078 5.98583 1.09204 5.36796 1.40525C4.75008 1.71846 4.23103 2.19668 3.86834 2.78687C3.50566 3.37706 3.31352 4.05617 3.31323 4.7489V15.2502C3.31336 15.9432 3.50551 16.6227 3.86836 17.2132C4.23121 17.8036 4.75057 18.282 5.3688 18.5952C5.98703 18.9084 6.67996 19.0441 7.37067 18.9874C8.06138 18.9307 8.72287 18.6837 9.28172 18.2738L16.4376 13.0232C16.9126 12.6748 17.2989 12.2195 17.5652 11.6941C17.8314 11.1686 17.9702 10.5878 17.9702 9.9988C17.9702 9.40975 17.8314 8.82898 17.5652 8.30355C17.2989 7.77811 16.9126 7.32277 16.4376 6.97443L16.4354 6.97518ZM15.5473 11.8133L8.39136 17.0639C8.05608 17.3089 7.65955 17.4564 7.24565 17.49C6.83175 17.5235 6.41663 17.4419 6.04625 17.2542C5.67586 17.0664 5.36465 16.7798 5.14706 16.4261C4.92948 16.0725 4.814 15.6655 4.81342 15.2502V4.7489C4.80926 4.33286 4.92255 3.92408 5.14029 3.56955C5.35803 3.21501 5.67138 2.92909 6.04432 2.74465C6.36153 2.5833 6.71231 2.49901 7.0682 2.49862C7.54518 2.50044 8.00898 2.6553 8.39136 2.94042L15.5473 8.19108C15.8319 8.40012 16.0634 8.67324 16.2229 8.98833C16.3824 9.30341 16.4656 9.65163 16.4656 10.0048C16.4656 10.358 16.3824 10.7062 16.2229 11.0213C16.0634 11.3364 15.8319 11.6095 15.5473 11.8185V11.8133Z"
        fill="white"
      />
    </svg>
  );
};

export default memo(VideoIcon);
